export const UPLOAD_FILE_HEADER_COPY = 'Upload CSV';
export const UPLOAD_FILE_SUB_HEADER_COPY =
  'Update existing assets or upload new ones';
export const UPLOAD_FILE_MAX_ROWS_COPY = 'Maximum number of rows: 500';
export const UPLOAD_FILE_GUIDANCE_COPY = 'Need guidance?';
export const UPLOAD_FILE_UPLOAD_BUTTON_COPY = 'Choose file';
export const UPLOAD_FILE_DOWNLOAD_TEMPLATE_LINK_COPY = 'Download a template';
